import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule, UrlModule } from '@spartacus/core';
import { CategoryNavigationModule, NavigationModule } from '@spartacus/storefront';
import { SharedModule } from 'src/app/shared/shared.module';
import { TCAcceptIsValidatedGuard } from '../../terms-and-conditions/guards/tc-accept-validated-guard';
import { CategoryNavComponent } from './category-nav.component';

@NgModule({
  imports: [
    CommonModule,
    CategoryNavigationModule,
    I18nModule,
    NavigationModule,
    MatIconModule,
    MatListModule,
    MatSidenavModule,
    SharedModule,
    RouterModule,
    UrlModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CategoryNavigationComponent: {
          component: CategoryNavComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [TCAcceptIsValidatedGuard],
        },
      },
    } as CmsConfig),
    CategoryNavComponent,
  ],
})
export class CategoryNavModule {}
